import Link from 'next/link'
import { useRouter } from 'next/router'
import ReactSVG from 'react-svg'
import { getUrlValues, getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'

export const PriceSort = ({ isMobileDevice = false }) => {
	const router = useRouter()

	const urlParts = (router.query['0'] || '').split('/')
	const group = router.query?.group || 'svi-djelovi'

	const urlPartsValues = getUrlValues({ group, urlParts })

	const urlLowest = getUrl(group, { ...urlPartsValues, sortByPrice: 'rastuce', page: 1 })
	const urlHighest = getUrl(group, { ...urlPartsValues, sortByPrice: 'opadajuce', page: 1 })

	return !isMobileDevice ? (
		<div className="vehicle-parts-price-sort">
			<div className="vehicle-parts-price-sort__buttons">
				<Link as={urlLowest.asUrl} href={urlLowest.href} passHref>
					<a className={`vehicle-parts-price-sort__button ${urlPartsValues?.sortByPrice === 'rastuce' ? 'active' : ''}`}>
						Najjeftinije
						<ReactSVG wrapper='span' src='/icons/najjeftinije.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
				<Link as={urlHighest.asUrl} href={urlHighest.href} passHref>
					<a className={`vehicle-parts-price-sort__button ${urlPartsValues?.sortByPrice === 'opadajuce' ? 'active' : ''}`}>
						Najskuplje
						<ReactSVG wrapper='span' src='/icons/najskuplje.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
			</div>
		</div>
	) : (
		<div className="vehicle-parts-price-sort vehicle-parts-price-sort" style={{ marginLeft: 'auto' }}>
			<div className="vehicle-parts-price-sort__buttons">
				<Link as={urlLowest.asUrl} href={urlLowest.href} passHref>
					<a className={`vehicle-parts-price-sort__button ${urlPartsValues?.sortByPrice === 'rastuce' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/najjeftinije.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
				<Link as={urlHighest.asUrl} href={urlHighest.href} passHref>
					<a className={`vehicle-parts-price-sort__button ${urlPartsValues?.sortByPrice === 'opadajuce' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/najskuplje.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
					</a>
				</Link>
			</div>
		</div>
	)
}

